module.exports = __webpack_public_path__ + "static/media/25th-logotype.98a5f80e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/25th-logotype.jpg
// module id = 1843
// module chunks = 0